import React from 'react';
import Icon from './Icon';

const Pipeline = ({ currentStage = 0, className = '' }) => {
  const steps = [
    { name: 'Ordered', key: 'ordered' },
    { name: 'Reviewed', key: 'reviewed' },
    { name: 'Refund\nFiled', key: 'refund-filed' },
    { name: 'Verified', key: 'verified' },
    { name: 'Paid', key: 'paid' },
  ];

  return (
    <div className={`pipeline ${className}`}>
      {steps.map((step, index) => {
        const isActive = index <= currentStage;
        const isCurrent = index === currentStage;
        
        return (
          <div 
            key={step.key} 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              flex: index < steps.length - 1 ? 1 : 'none' 
            }}
          >
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              gap: '3px' 
            }}>
              <div 
                className="pipeline-step"
                style={{
                  background: isActive 
                    ? (isCurrent ? 'var(--primary)' : 'var(--primary-dark)') 
                    : 'var(--bg-deep)',
                  color: isActive ? 'white' : 'var(--text-muted)',
                  boxShadow: isCurrent ? '0 0 0 3px var(--primary-glow)' : 'none',
                }}
              >
                {index < currentStage ? (
                  <Icon name="tick" size={11} color="white" />
                ) : (
                  index + 1
                )}
              </div>
              <span style={{
                fontSize: '9px',
                fontWeight: 700,
                color: isActive ? 'var(--primary-dark)' : 'var(--text-muted)',
                textTransform: 'uppercase',
                letterSpacing: '0.3px',
                textAlign: 'center',
                lineHeight: 1.2,
                whiteSpace: 'pre-line'
              }}>
                {step.name}
              </span>
            </div>
            
            {index < steps.length - 1 && (
              <div 
                className="pipeline-line"
                style={{
                  background: index < currentStage ? 'var(--primary)' : 'var(--border)',
                  marginBottom: 14,
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Pipeline;
